module.exports = __webpack_public_path__ + "img/people-arrows-left-right.7d104423.svg";